import { useMemo, useState } from 'react'
import { Trans } from 'react-i18next'
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities'

import { DefaultVariableResult, VariableResultMenu } from '@makyoapp/makyo-common'
import { ArrowShortRight16, Menu16 } from '@makyoapp/makyo-icon/icon'
import { Chip, ChipProps } from '@makyoapp/makyo-ui'

import { useAppBuilderContext } from '@/context/AppBuilderContext'

import { VariableMenuBody } from '../VariableMenu'
import { useVariableSelectContext } from '../VariableSelectContext'
import { DragHandler, EditDD } from './components'

export default function ChipMenu({
  value,
  chipProps: { listeners, ...chipProps },
  index,
}: {
  value: VariableResultMenu
  index: number
  chipProps: ChipProps & { listeners?: SyntheticListenerMap }
}) {
  const { onChange, value: contextValue, multiple } = useVariableSelectContext()
  const { menus } = useAppBuilderContext()
  const [show, setShow] = useState(false)
  const title = useMemo(() => {
    return menus?.find(({ id }) => id === value.value)?.title
  }, [menus, value.value])
  return (
    <Chip
      {...chipProps}
      portalTip
      tipClassName='text-m-m'
      title={
        <div className='flex-c'>
          <div className='text-center whitespace-nowrap'>
            <Trans>Menu</Trans>
          </div>
          <ArrowShortRight16 />
          <div className='flex-c whitespace-nowrap'>
            <Menu16 />
            {title}
          </div>
        </div>
      }
    >
      <DragHandler listeners={listeners} />
      <div className='w-full txt'>
        <Trans>Menu</Trans>
      </div>
      <EditDD show={show} onToggle={setShow} menuWrapperClassName='py-2' menuClassName='min-w-[200px]'>
        <VariableMenuBody
          onDone={(newVal) => {
            const nextVal = multiple
              ? ([...((contextValue as DefaultVariableResult[]) ?? [])] as DefaultVariableResult[])
              : newVal

            if (multiple) {
              ;(nextVal as DefaultVariableResult[])[index] = newVal
            }
            onChange(nextVal)
          }}
          value={value}
          setShow={setShow}
        />
      </EditDD>
    </Chip>
  )
}
